module.exports = __webpack_public_path__ + "img/1440.51d7005b.jpg";